<div class="card">
  <div class="card-header text-start">
    <div class="mb-3">
      <h4>Document</h4>
    </div>
    <div style="display:flex; justify-content:space-between">
      <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)">Quick Filters<i
          class="feather icon-filter ml-2"></i></button>
      <div>
        <div class="btn-group" ngbDropdown role="group">
          <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
          <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
            style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
            <div class="form-group">
              <div *ngIf="columnDefs" class="list-group ng-option">
                <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                  <label class="list-group-item p-2">
                    <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}"
                      name="{{column.headerName}}" (change)="updateSelectedColumn($event)"
                      [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                    {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">Export Excel<i
            class="feather icon-download ml-2"></i></button>
        <button class="btn bg-danger-custom" (click)="openModalConfirm(confirmModal)">Upload document</button>
      </div>
    </div>
  </div>

  <div *ngIf="quickFilterShow" class="ro" style="min-height: 100px">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <label class="col-form-label" for="documentType">Document Type</label>
            <ng-select #filStatus [(ngModel)]="documentType" id="documentType" placeholder="Select documentType"
              [inputAttrs]="{maxlength: '100'}" (focus)="fun('documentType')" (focusout)="funover('documentType')">
              <ng-option value="Merchant Agreement">Merchant Agreement</ng-option>
              <ng-option value="Other">Other</ng-option>
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="col-form-label" for="merchantName">Merchant Name
            </label>
            <input class="form-control" [(ngModel)]="merchantName" id="merchantName" placeholder="Enter Merchant Name"
              (focus)="fun('merchantName')" (focusout)="funover('merchantName')">
          </div>
          <div class="col-sm-3">
            <label class="col-form-label" for="uploadedDate">Uploaded Date
            </label>
            <input #filUploadedDate [(ngModel)]="uploadedDate" ngbDatepicker #d="ngbDatepicker" class="form-control"
              id="uploadedDate" placeholder="yyyy-mm-dd" [maxDate]="maxUploadedDate" (click)="d.toggle()"
              (ngModelChange)="changeUploadedDate()" />
          </div>
          <div class="col-md-3">
            <label class="col-form-label" for="signedCompletionDate">Signed Date
            </label>
            <input #filSignedDate [(ngModel)]="signedCompletionDate" ngbDatepicker #d1="ngbDatepicker" class="form-control"
              id="signedCompletionDate" placeholder="yyyy-mm-dd" [maxDate]="maxSignedDate" (click)="d1.toggle()"
              (ngModelChange)="changeSignedDate()" />
          </div>
          <div class="col-sm-3">
            <label class="col-form-label" for="uploadedBy">Uploaded By
            </label>
            <input class="form-control" [(ngModel)]="uploadedBy" id="uploadedBy" placeholder="Enter Uploaded By"
              (focus)="fun('uploadedBy')" (focusout)="funover('uploadedBy')">
          </div>
          <div class="col-md-4" style="margin-top: 3%;">
            <button (click)="onSearchBtnClick()" class="btn bg-danger-custom" type="button"><i
                class="feather icon-search"></i>Search
            </button>
            <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body m-0">
    <div class="row mb-0" style="min-height: 380px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]="true" (filterChanged)="onFilterChange($event)"
          (filterModified)="onFilterModified($event)" (filterOpened)="onFilterOpened($event)"
          (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" (search)="globalSearch"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [tooltipShowDelay]="0"
          [enableCellTextSelection]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
          style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <div class="row mt-2" *ngIf="rowData.length">
      <div class="col-4 col-xs-4">
        <select [(ngModel)]="pageRecords" (ngModelChange)="onPageSizeChanges($event)"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{ pageNum }}</option>
        </select>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="pageNumber" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageRecords" [rotate]="true"
          class="d-flex justify-content-end col-8 align-right">
        </ngb-pagination>
      </div>
    </div>
  </div>

  <ng-template #confirmModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Upload Document</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body" style="min-height: 80vh;">
      <div class="row">
        <div class="col-sm-6">
          <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required"
              style="color:red;">*</span> </label>
          <ng-select (change)="onSelectMerchant($event)" placeholder="Select Merchant">
            <ng-option *ngFor="let merchant of Resultdata" [value]="merchant">
              {{merchant.fullName}} ({{merchant.identifier}})
            </ng-option>
          </ng-select>
        </div>
      </div>
      <br />
      <div class="row" *ngIf="merchantSelected && UBOList.length > 0">

        <p class="color info ml-2" class="info">
          <i class="feather icon-info" style="margin-right:1rem"></i>You can reorder the sequence by dragging and
          dropping the columns. <span style="color:red"> You may select up to a maximum of 5 authorized signatories.</span>
        </p>

        <table style="margin-bottom:2rem" class="table table-bordered">
          <thead>
            <tr style="background:#fdf7cc">
              <th>UBO Name</th>
              <th>UBO Email Address</th>
              <th>Sequence</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            <tr *ngFor="let ubo of UBOList; let i = index" cdkDrag>
              <td>{{ubo.signatoryName}}</td>
              <td>{{ubo.signatoryEmail}}</td>
              <td>{{ ubo.sequence}}</td>
              <td>
                <button style="border: #dfa111; background: #dfa111; color: #fff;" title="Delete"
                 (click)="removeRow(i)"><i class="feather icon-x" style="color:white; font-size:10px;"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <div class="form-group">
          <label for="documentTypeEntry">Document Type <span aria-hidden="true" class="symbol required"
                                                                      style="color:red;">*</span></label>
          <select id="documentTypeEntry" class="form-control" [(ngModel)]="documentTypeEntry">
            <option value="Merchant Agreement">Merchant Agreement</option>
            <option value="Other">Other</option>
          </select>

          <br />
          <label for="fileUpload" *ngIf="!uploadedFile?.name">Upload Document (PDF only, max 5MB)</label>
          <div *ngIf="!uploadedFile?.name" class="upload-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
            (click)="fileInput.click()">
            <p>Drag & Drop or <span>Choose a file</span></p>
            <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept="application/pdf" />
          </div>

          <div class="file-info mt-3" *ngIf="uploadedFile?.name">
            <div style="display: flex;justify-content: space-between;">
              <span>{{ uploadedFile?.name }}</span>
              <button type="button" class="btn btn-link" style="color:#9F080E;text-decoration: underline;"
                (click)="replaceFile()">Replace</button>
            </div>
          </div>

          <div *ngIf="fileErrorMessage" class="text-danger">
            {{ fileErrorMessage }}
          </div>
        </div>
        <p class="color info ml-2" class="info">
          <i class="feather icon-info"></i> The recepient will receive an email to sign the document with UAE Pass
        </p>
      </div>
      <div class="row" *ngIf="merchantSelected && UBOList.length == 0">
        No Record found
      </div>
    </div>
    <div class="modal-footer" *ngIf="merchantSelected && UBOList.length > 0">
      <button type="submit" class="btn btn-primary" (click)="submitForm()" [disabled]="!enableButton()" title="You may select up to a maximum of 5 authorized signatories">
        Send for Signature
      </button>
      <button type="button" class="btn btn-secondary" (click)="resetPopup();modal.dismiss('cancel')">Cancel</button>
    </div>
  </ng-template>
</div>